import React from 'react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { WhatsAppButton } from './WhatsAppButton';
import { ArrowUpRight } from 'lucide-react';
const STAY_IMAGES = [{
  src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6NDI3MDQ0NzQ%3D/original/f8c79b29-e4b3-444c-a36f-e29b7eb7c294.jpeg?im_w=1440',
  alt: 'The accommodation exterior'
}, {
  src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-42704474/original/fe32518c-f3bb-4193-8ba1-f8c45b2af0e0.jpeg?im_w=1440',
  alt: 'Living space'
}, {
  src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-42704474/original/d298ea7c-80e4-4896-9e42-eea8073a0aef.jpeg?im_w=1440',
  alt: 'Bedroom and sleeping area'
}, {
  src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-42704474/original/c071eb0a-70c7-43b2-a6bb-3c2fb864829c.jpeg?im_w=1440',
  alt: 'Interior detail'
}, {
  src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6NDI3MDQ0NzQ%3D/original/4766b4b4-5146-42d0-935d-f879c5a2dd1b.jpeg?im_w=1440',
  alt: 'Property detail'
}, {
  src: 'https://a0.muscache.com/im/pictures/hosting/Hosting-42704474/original/c9161975-fbf9-4c7d-99ec-f44bc02a4ad4.jpeg?im_w=1440',
  alt: 'Outdoor space at the accommodation'
}];
export function StayOnTheLand() {
  return <section id="stay" className="py-20 md:py-32 px-6 md:px-12 bg-cream relative scroll-mt-16" data-id="element-163">
      <div className="max-w-6xl mx-auto" data-id="element-164">
        <div className="max-w-3xl mb-12 md:mb-16" data-id="element-165">
          <FadeIn data-id="element-166">
            <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-167">
              The Stay
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-168">
            <h2 className="font-serif text-4xl md:text-5xl text-pine mb-6" data-id="element-169">
              Stay on the Land
            </h2>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-170">
            <p className="text-xl text-clay font-light leading-relaxed" data-id="element-171">
              Make it more than a visit. Stay overnight, wake up slowly, and
              keep the reset going.
            </p>
          </FadeIn>
        </div>

        {/* Gallery: 1 large + 2-image strip */}
        <FadeIn delay={0.2} data-id="element-172">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4 mb-6" data-id="element-173">
            <div className="md:col-span-2 md:row-span-2 relative aspect-[4/3] md:aspect-auto md:h-[60vh] overflow-hidden rounded-sm" data-id="element-174">
              <img src={STAY_IMAGES[0].src} alt={STAY_IMAGES[0].alt} className="w-full h-full object-cover" data-id="element-175" />
            </div>
            <div className="relative aspect-[4/3] overflow-hidden rounded-sm" data-id="element-176">
              <img src={STAY_IMAGES[1].src} alt={STAY_IMAGES[1].alt} className="w-full h-full object-cover" data-id="element-177" />
            </div>
            <div className="relative aspect-[4/3] overflow-hidden rounded-sm" data-id="element-178">
              <img src={STAY_IMAGES[2].src} alt={STAY_IMAGES[2].alt} className="w-full h-full object-cover" data-id="element-179" />
            </div>
          </div>
        </FadeIn>

        {/* Thumbnail row */}
        <FadeIn delay={0.3} data-id="element-180">
          <div className="grid grid-cols-3 gap-3 md:gap-4 mb-16" data-id="element-181">
            {STAY_IMAGES.slice(3).map((img, i) => <div key={i} className="relative aspect-[4/3] overflow-hidden rounded-sm" data-id="element-182">
                <img src={img.src} alt={img.alt} className="w-full h-full object-cover" data-id="element-183" />
              </div>)}
          </div>
        </FadeIn>

        {/* Details + CTAs */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-184">
          <FadeIn delay={0.2} data-id="element-185">
            <h3 className="font-serif text-2xl text-pine mb-6" data-id="element-186">What you get</h3>
            <ul className="space-y-4 text-clay font-light text-lg" data-id="element-187">
              <li className="flex items-center gap-4" data-id="element-188">
                <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-189" />
                Sleeps up to 6 people
              </li>
              <li className="flex items-center gap-4" data-id="element-190">
                <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-191" />
                Private pool
              </li>
              <li className="flex items-center gap-4" data-id="element-192">
                <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-193" />
                Outdoor kitchen
              </li>
              <li className="flex items-center gap-4" data-id="element-194">
                <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-195" />
                Peaceful nature setting near Pardes Hanna
              </li>
              <li className="flex items-center gap-4" data-id="element-196">
                <span className="w-1.5 h-1.5 rounded-full bg-ember" data-id="element-197" />
                Steps from the sauna, dome, and fire pit
              </li>
            </ul>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-198">
            <h3 className="font-serif text-2xl text-pine mb-6" data-id="element-199">
              Book your stay
            </h3>
            <div className="flex flex-col gap-3" data-id="element-200">
              <a href={LINKS.airbnb} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between px-6 py-4 bg-cream border border-pine/20 text-pine rounded-sm hover:bg-pine/5 hover:border-pine/40 transition-colors" data-id="element-201">
                <span className="font-medium tracking-wide" data-id="element-202">
                  View on Airbnb
                </span>
                <ArrowUpRight className="w-4 h-4 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-203" />
              </a>
              <a href={LINKS.booking} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between px-6 py-4 bg-cream border border-pine/20 text-pine rounded-sm hover:bg-pine/5 hover:border-pine/40 transition-colors" data-id="element-204">
                <span className="font-medium tracking-wide" data-id="element-205">
                  View on Booking.com
                </span>
                <ArrowUpRight className="w-4 h-4 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-206" />
              </a>
              <div className="flex items-center gap-4 my-2" data-id="element-207">
                <div className="h-px bg-pine/15 flex-1" data-id="element-208" />
                <span className="text-clay/60 text-sm uppercase tracking-widest" data-id="element-209">
                  or
                </span>
                <div className="h-px bg-pine/15 flex-1" data-id="element-210" />
              </div>
              <WhatsAppButton label="Message Zev on WhatsApp" className="w-full" data-id="element-211" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}